<template>
  <div>
      <br /><br /><br />
      <div class="container">
  <h5 class=" txtBlack text-center">
            {{ $t('customer-support') }}
          </h5>
          <hr />
          <div class=" seasoncast-card p-5">
          <p v-if="email == undefined">Login to your SeasonCast account to access our support chat widget. This is the fastest way to get a response from us. If you do not have an account, use the other methods below to contact us. <br /></p>
       <p v-else> Use the SeasonCast Chat Widget in the bottom right corner of the screen to contact us directly. This is the fastest way to get a response from us. </p>
       <button  v-if="email" id="trigger-intercom" class="btn btn-block btn-dark">Trigger SeasonCast Chat Widget</button>
        <a href="https://seasoncast.freshdesk.com/support/home" class="btn btn-block btn-dark">Go to SeasonCast Customer Support Page</a>
        <a  v-if="email == undefined" href="/account" class="btn btn-block btn-secondary">Login to Access Chat Widget</a>

        <a  v-if="email == undefined" href="mailto:support@seasoncast.com" class="btn btn-block btn-secondary">Email Us</a>
</div></div>
<br /><br />
     <!-- <div class="container ">
   <h5 class=" txtBlack text-center">

            {{ $t('contact-us-directly') }}
          </h5>
          <hr />
          <div class="seasoncast-card p-5" >
          <p>{{ $t('if-you-need-to-contact-us-directly-please-contact-us-at-support-seasoncast-com-or-fill-the-form-below') }}
</p>
     
<iframe title="Feedback Form" class="freshwidget-embedded-form" id="freshwidget-embedded-form" src="https://seasoncast.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&screenshot=No" scrolling="no" height="500px" width="100%" frameborder="0" >
</iframe></div>     </div> -->

     <div class="container ">
   <h5 class=" txtBlack text-center">
        SeasonCast server uptime status
      </h5>
      <hr />
       <div class="seasoncast-card p-5">
      <a href="https://status.seasoncast.com/" class="btn btn-block btn-dark">Go to SeasonCast Server Status Page</a>
</div></div>
  <br />
</div>
</template>
<script >

import cookie from "cookie.js"


export default {
  name: 'Support',
  data: function() {
    return {
      email: cookie.get("broadcaster-email") ?? cookie.get("viewer-email"),  
    }
  },
  methods:{
 
},
  components: {
  
  },
  async created() {
    window.intercomSettings = {
  app_id: "qbuqg2ke",
  custom_launcher_selector:'#trigger-intercom',
};
    window.Intercom("boot", {
  api_base: "https://api-iam.intercom.io",
  app_id: "qbuqg2ke",
  email: cookie.get("broadcaster-email") ?? cookie.get("viewer-email")
});

  },
}
</script>

